var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVendors = function SvgVendors(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/16*16/informative/vendors"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M10.3281 1C11.0353 1 11.7221 1.2409 12.2744 1.68262L14.3174 3.31543C14.749 3.66074 14.9999 4.18458 15 4.7373V11.8848C14.9999 13.605 13.605 14.9999 11.8848 15H4.11523C2.39494 15 1.00007 13.605 1 11.8848V4.7373C1.0001 4.18455 1.25098 3.66074 1.68262 3.31543L3.72559 1.68262C4.27781 1.24095 4.96378 1.00004 5.6709 1H10.3281ZM10.4668 4.63965V6.05762C10.4667 7.42009 9.36242 8.52412 8 8.52441C6.63733 8.52441 5.53233 7.42026 5.53223 6.05762V4.63965H2.05664C2.05253 4.67176 2.04982 4.70452 2.0498 4.7373V11.8848C2.04987 13.0252 2.97481 13.9502 4.11523 13.9502H11.8848C13.0251 13.9501 13.9501 13.0251 13.9502 11.8848V4.7373C13.9502 4.70452 13.9475 4.67176 13.9434 4.63965H10.4668ZM6.58203 6.05762C6.58214 6.84039 7.2172 7.47461 8 7.47461C8.78255 7.47432 9.41689 6.84021 9.41699 6.05762V4.63965H6.58203V6.05762ZM5.6709 2.0498C5.20206 2.04985 4.74696 2.21005 4.38086 2.50293L3.02148 3.58984H12.9785L11.6191 2.50293C11.253 2.21001 10.797 2.04981 10.3281 2.0498H5.6709Z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVendors);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "vendors.397ff3de12d0657a97db9e9816b2d9d6.svg";